import {injectable} from "inversify";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";
import {PlanExtensionSimulateHireEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_simulate_hire.entity";
import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";

@injectable()
export abstract class PlanExtensionsCatalogRepository {

    public abstract listCatalog(includeDeleted?: boolean): Promise<PlanExtensionCatalogEntity[]>;
    public abstract getCatalogById(id: string): Promise<PlanExtensionCatalogEntity>;
    public abstract simulateHire(idExtension: string): Promise<PlanExtensionSimulateHireEntity>;
    public abstract hire(idExtension: string): Promise<CompanyExtensionEntity>;
    public abstract unsubscribe(id: string): Promise<void>;
    public abstract reactivate(id: string): Promise<void>;
    public abstract listInstalled(): Promise<CompanyExtensionEntity[]>;
}
